<div class="rounded-2xl bg-white p-[16px] shadow-[0px_0px_8px_0px_rgba(0,0,0,0.12)]">
  <app-category-filters-component (applyFilters)="applyFilters($event)" (resetFilters)="resetFilters()" />

  <app-category-table-component
    [categories]="categories()"
    [state]="state()"
    [currentPage]="currentPage()"
    [itemsPerPage]="itemsPerPage()"
    [isFiltersApplied]="isFiltersApplied()"
    (retry)="loadCategories()"
    (viewCategory)="onViewCategory($event)"
    (editCategory)="onEditCategory($event)"
    (deleteCategory)="openDeleteDialog($event)" />
</div>

@if (state() === "success") {
  <app-pagination
    [itemsPerPage]="itemsPerPage()"
    [currentPage]="currentPage()"
    [getPageNumbers]="pageNumbers()"
    [totalPages]="totalPages()"
    [startItem]="startItem()"
    [endItem]="endItem()"
    [totalItems]="totalItems()"
    (previousPage)="onPageChange(currentPage() - 1)"
    (nextPage)="onPageChange(currentPage() + 1)"
    (goToPage)="onPageChange($event)"
    (changePageNumber)="onPageSizeChange(+$event)" />
}

@if (categoryToDelete()) {
  <app-confirmation-dialog
    layout="start"
    [title]="deleteTitle"
    [description]="deleteDescription()"
    [confirmContent]="deleteConfirm"
    [cancelContent]="deleteCancel"
    [isLoading]="deleting()"
    [error]="deleteError()"
    (onSubmit)="confirmDelete()"
    (onCancel)="closeDeleteDialog()" />
}

@if (showSuccessMessage()) {
  <app-successful-notification type="success" [title]="deleteSuccess" />
}
